import React, { useState, useEffect } from 'react';
import NavContainer from './styles';
import logo from '../../assets/BoisLogo.png';
import { FaBars, FaSearch, FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import CartButtons from '../CartButtons/';
import { useProductsContext } from '../../context/products_context';
import { useUserContext } from '../../context/user_context';
import { useLanguageContext } from '../../context/language_context';

const Nav = () => {
  const { currentUser } = useUserContext();
  const { openSidebar, isSidebarOpen, products } = useProductsContext();
  const { t, isArabic } = useLanguageContext();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  // Get unique categories from products
  const categories = [...new Set(products.map(p => p.category))].filter(Boolean).slice(0, 4);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <NavContainer className={`${isScrolled ? 'scrolled' : ''} ${isSidebarOpen ? 'sidebar-open' : ''}`} dir={isArabic ? 'rtl' : 'ltr'}>
      <div className='nav-center'>
        {/* Left - Logo */}
        <div className='nav-logo'>
          <Link to='/'>
            <img src={logo} alt='Art & Bois' />
          </Link>
        </div>

        {/* Center - Navigation Links */}
        <ul className='nav-links'>
          {/* Main Navigation Group */}
          <div className='nav-group main-nav'>
            <li>
              <Link to='/' className={`nav-link main-link ${isActive('/') ? 'active' : ''}`}>
                {t.nav.home}
              </Link>
            </li>
            <li>
              <Link to='/products' className={`nav-link main-link ${isActive('/products') ? 'active' : ''}`}>
                {t.nav.products}
              </Link>
            </li>
            <li>
              <Link to='/about' className={`nav-link main-link ${isActive('/about') ? 'active' : ''}`}>
                {t.nav.about}
              </Link>
            </li>
            {currentUser && (
              <li>
                <Link to='/orders' className={`nav-link main-link ${isActive('/orders') ? 'active' : ''}`}>
                  {isArabic ? 'طلباتي' : 'My Orders'}
                </Link>
              </li>
            )}
          </div>

          {/* Separator */}
          <div className='nav-separator'></div>

          {/* Categories Group */}
          <div className='nav-group categories-nav'>
            {categories.map((category, index) => (
              <li key={index}>
                <Link 
                  to={`/products?category=${encodeURIComponent(category)}`} 
                  className='nav-link category-link'
                >
                  {category}
                </Link>
              </li>
            ))}
          </div>
        </ul>

        {/* Right - Icons + Mobile Toggle */}
        <div className='nav-right'>
          <div className='nav-icons'>
            <button 
              className='icon-btn search-btn' 
              onClick={() => setSearchOpen(!searchOpen)}
              aria-label='Search'
            >
              {searchOpen ? <FaTimes /> : <FaSearch />}
            </button>
            <CartButtons />
          </div>

          {/* Mobile Toggle */}
          <button type='button' className='nav-toggle' onClick={openSidebar}>
            <FaBars />
          </button>
        </div>
      </div>

      {/* Search Overlay */}
      {searchOpen && (
        <div className='search-overlay'>
          <div className='search-container'>
            <input 
              type='text' 
              placeholder={t.nav?.search || 'Search products...'}
              autoFocus
            />
            <FaSearch className='search-icon' />
          </div>
        </div>
      )}
    </NavContainer>
  );
};

export default Nav;
